import { createReducer } from '@reduxjs/toolkit'
import { TetrisGroup } from 'interfaces/api/tetrisGroups.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createTetrisGroup,
  getAllTetrisGroups,
  removeTetrisGroup,
  setSingleTetrisGroup,
  setTetrisGroupValidationErrors,
  updateTetrisGroup,
} from './actions'

interface TetrisGroupsState {
  list: {
    loading: boolean
    items: TetrisGroup[]
  }
  single: {
    loading: boolean
    item: TetrisGroup | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: TetrisGroupsState = {
  list: {
    loading: false,
    items: [],
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const tetrisGroupsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllTetrisGroups.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllTetrisGroups.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllTetrisGroups.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setTetrisGroupValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([setSingleTetrisGroup], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase([createTetrisGroup.pending, removeTetrisGroup.pending, updateTetrisGroup.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createTetrisGroup.rejected, removeTetrisGroup.rejected, updateTetrisGroup.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createTetrisGroup.fulfilled, removeTetrisGroup.fulfilled, updateTetrisGroup.fulfilled], (state) => {
      state.single.loading = false
    })
})
